module.exports = __webpack_public_path__ + "static/media/plant-recycle.9d44b2dc.jpg";